import React from 'react';

const ReplyIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="M20 18v-2a4 4 0 0 0-4-4H4"/>
            <path d="m9 17-5-5 5-5"/>
        </svg>
    );
};

export default ReplyIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/ReplyIcon.jsx